module.exports = __webpack_public_path__ + "static/media/logo-linewords.7216ba89.png";